import api from 'utils/api';

export interface ExportOrgParams {
  isAll: boolean;
  orgIds: string;
}

const excelDefinitionService = {
  importSku: (params: FormData) => {
    return api.put(`/skus/import`, params);
  },
  exportBaseSku: () => {
    return `${process.env.REACT_APP_API_URL}/skus/base-export`;
  },
  exportOrgSku: (params: ExportOrgParams) => {
    return `${process.env.REACT_APP_API_URL}/skus/org-export?isAll=${params.isAll}&orgIds=${params.orgIds}`;
  },
  importEquipments: (params: FormData) => {
    return api.put(`/equipments/import`, params);
  },
  exportBaseEquipments: () => {
    return `${process.env.REACT_APP_API_URL}/equipments/base-export`;
  },
  exportOrgEquipments: (params: ExportOrgParams) => {
    return `${process.env.REACT_APP_API_URL}/equipments/org-export?isAll=${params.isAll}&orgIds=${params.orgIds}`;
  },
  importServices: (params: FormData) => {
    return api.put(`/services/import`, params);
  },
  exportBaseServices: () => {
    return `${process.env.REACT_APP_API_URL}/services/base-export`;
  },
  exportOrgServices: (params: ExportOrgParams) => {
    return `${process.env.REACT_APP_API_URL}/services/org-export?isAll=${params.isAll}&orgIds=${params.orgIds}`;
  },
  importMaterials: (params: FormData) => {
    return api.put(`/materials/import`, params);
  },
  exportBaseMaterials: () => {
    return `${process.env.REACT_APP_API_URL}/materials/base-export`;
  },
  exportOrgMaterials: (params: ExportOrgParams) => {
    return `${process.env.REACT_APP_API_URL}/materials/org-export?isAll=${params.isAll}&orgIds=${params.orgIds}`;
  },
  importParcels: (params: FormData) => {
    return api.put(`/parcels/import`, params);
  },
  exportBaseParcels: () => {
    return `${process.env.REACT_APP_API_URL}/parcels/base-export`;
  },
  exportOrgParcels: (params: ExportOrgParams) => {
    return `${process.env.REACT_APP_API_URL}/parcels/org-export?isAll=${params.isAll}&orgIds=${params.orgIds}`;
  },
};

export default excelDefinitionService;
